// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.refereePage .genericPageMessage {
  width: 100%;
}
.refereePage .flowLayout .dataCaptureHeading {
  background-color: #fff;
  height: 86px;
  width: 100%;
  border-bottom: 1px solid rgba(38, 38, 38, 0.2);
  left: 0;
}
.refereePage .flowLayout .dataCaptureHeading.noProgressBar {
  height: 44px;
}
.refereePage .flowLayout .dataCaptureHeading .progressBar {
  margin: 4px auto;
}
.refereePage .flowLayout .dataCaptureHeading + * {
  margin-top: 86px;
}
.refereePage .flowLayout .logo {
  display: block;
  margin: 6px auto 0 auto;
  height: 25px;
}
.refereePage .pageBody {
  margin: 86px auto 155px auto;
  padding-top: 16px;
  width: 100%;
  color: #262626;
}
.refereePage .pageBody h1 {
  margin-top: 10px;
}
.refereePage .pageBody h2 {
  font-size: 32px;
}
.refereePage .pageBody section,
.refereePage .pageBody > p {
  margin: 20px auto 20px auto;
  font-size: 15px;
  line-height: 20px;
}
.refereePage .pageBody .pageIntroduction {
  margin: 0 auto 7px auto;
  opacity: 1;
}
.refereePage .pageBody section p {
  margin-bottom: 5px;
}
.refereePage .pageBody section ul {
  margin: 10px auto;
  padding-left: 25px;
}
.refereePage .pageBody section ul.borderContent {
  list-style-type: none;
  margin: 5px auto;
}
.refereePage .pageBody .k-form-field:last-child {
  margin-bottom: 0px;
}
@media (max-width: 845px) {
  .refereePage .pageBody {
    width: 320px;
  }
  .refereePage .pageBody .dataCapturePageMessage {
    margin-left: 0;
    margin-right: 0;
  }
}
.borderContent {
  border: 1px solid rgba(38, 38, 38, 0.2);
  border-radius: 4px;
  background-color: white;
  padding: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/layouts/RefereePageLayout.less"],"names":[],"mappings":"AAEA;EAIE,WAAA;AAJF;AAAA;EASG,sBAAA;EACA,YAAA;EACA,WAAA;EACA,8CAAA;EACA,OAAA;AANH;AAQG;EACC,YAAA;AANJ;AAVA;EAoBI,gBAAA;AAPJ;AAbA;EAyBG,gBAAA;AATH;AAhBA;EA6BG,cAAA;EACA,uBAAA;EACA,YAAA;AAVH;AArBA;EAoCE,4BAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;AAZF;AA3BA;EA0CG,gBAAA;AAZH;AA9BA;EA8CG,eAAA;AAbH;AAjCA;;EAmDG,2BAAA;EACA,eAAA;EACA,iBAAA;AAdH;AAvCA;EAyDG,uBAAA;EACA,UAAA;AAfH;AA3CA;EA+DI,kBAAA;AAjBJ;AA9CA;EAmEI,iBAAA;EACA,kBAAA;AAlBJ;AAoBI;EACC,qBAAA;EACA,gBAAA;AAlBL;AAtDA;EA8EG,kBAAA;AArBH;AAwBE;EAAA;IACC,YAAA;EArBD;EAoBA;IAIE,cAAA;IACA,eAAA;EArBF;AACF;AA0BA;EACC,uCAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;AAxBD","sourcesContent":["@import (reference) '../constants.less';\n\n.refereePage {\n\t@dataCaptureHeadingHeight: 86px;\n\n\t.genericPageMessage {\n\t\twidth: 100%;\n\t}\n\n\t.flowLayout {\n\t\t.dataCaptureHeading {\n\t\t\tbackground-color: #fff;\n\t\t\theight: @dataCaptureHeadingHeight;\n\t\t\twidth: 100%;\n\t\t\tborder-bottom: 1px solid rgba(38, 38, 38, 0.2);\n\t\t\tleft: 0;\n\n\t\t\t&.noProgressBar {\n\t\t\t\theight: 44px;\n\t\t\t}\n\n\t\t\t.progressBar {\n\t\t\t\tmargin: 4px auto;\n\t\t\t}\n\t\t}\n\n\t\t.dataCaptureHeading + * {\n\t\t\tmargin-top: @dataCaptureHeadingHeight;\n\t\t}\n\n\t\t.logo {\n\t\t\tdisplay: block;\n\t\t\tmargin: 6px auto 0 auto;\n\t\t\theight: 25px;\n\t\t}\n\t}\n\n\t.pageBody {\n\t\tmargin: @dataCaptureHeadingHeight auto 155px auto;\n\t\tpadding-top: 16px;\n\t\twidth: 100%;\n\t\tcolor: @grey26;\n\n\t\th1 {\n\t\t\tmargin-top: 10px;\n\t\t}\n\n\t\th2 {\n\t\t\tfont-size: 32px;\n\t\t}\n\n\t\tsection,\n\t\t> p {\n\t\t\tmargin: 20px auto 20px auto;\n\t\t\tfont-size: 15px;\n\t\t\tline-height: 20px;\n\t\t}\n\n\t\t.pageIntroduction {\n\t\t\tmargin: 0 auto 7px auto;\n\t\t\topacity: 1;\n\t\t}\n\n\t\tsection {\n\t\t\tp {\n\t\t\t\tmargin-bottom: 5px;\n\t\t\t}\n\n\t\t\tul {\n\t\t\t\tmargin: 10px auto;\n\t\t\t\tpadding-left: 25px;\n\n\t\t\t\t&.borderContent {\n\t\t\t\t\tlist-style-type: none;\n\t\t\t\t\tmargin: 5px auto;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.k-form-field:last-child {\n\t\t\tmargin-bottom: 0px;\n\t\t}\n\n\t\t@media (max-width: @dataCaptureOneColumnFieldsPageMaxWidth) {\n\t\t\twidth: @formFieldsetWidthForMobile;\n\n\t\t\t.dataCapturePageMessage {\n\t\t\t\tmargin-left: 0;\n\t\t\t\tmargin-right: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.borderContent {\n\tborder: @containerBorder;\n\tborder-radius: 4px;\n\tbackground-color: white;\n\tpadding: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
